// @ts-nocheck
import { is_function } from "./is_function"

/**
 * Checks if value is an iterator.
 *
 * @param obj - Value to check
 * @returns True if has next method
 */
export const is_iterator = obj => {
  if (obj) {
    return is_function(obj.next)
  }
  return false
}
